export const movieData = [
    {
        id:1,
        name:"Weathering With You",
        lang: "English",
        duration: 114,
        desc: "Set during a period of exceptionally rainy weather, high-school boy Hodaka Morishima runs away from his troubled rural home to Tokyo and befriends an orphan girl who can manipulate the weather.",
        poster: "https://m.media-amazon.com/images/M/MV5BNzE4ZDEzOGUtYWFjNC00ODczLTljOGQtZGNjNzhjNjdjNjgzXkEyXkFqcGdeQXVyNzE5ODMwNzI@._V1_FMjpg_UX1000_.jpg",
        trailer: "https://www.youtube.com/watch?v=ps8qwWG8Uio",
    },
    {
        id: 2,
        name: "Your Name",
        lang: "English",
        duration: 112,
        desc: "Two teenagers share a profound, magical connection upon discovering they are swapping bodies. Things manage to become even more complicated when the boy and girl decide to meet in person.",
        poster: "https://m.media-amazon.com/images/M/MV5BNGYyNmI3M2YtNzYzZS00OTViLTkxYjAtZDIyZmE1Y2U1ZmQ2XkEyXkFqcGdeQXVyMTA4NjE0NjEy._V1_.jpg",
        trailer: "https://www.youtube.com/watch?v=3KR8_igDs1Y",
    },
    {
        id: 3,
        name: "A Silent Voice",
        lang: "English",
        duration: 129,
        desc: "When a grade school student with impaired hearing is bullied mercilessly, she transfers to another school. Years later, one of her former tormentors sets out to make amends.",
        poster: "https://m.media-amazon.com/images/M/MV5BZGRkOGMxYTUtZTBhYS00NzI3LWEzMDQtOWRhMmNjNjJjMzM4XkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg",
        trailer: "https://www.youtube.com/watch?v=nfK6UgLra7g",
    },
    {
        id: 4,
        name: "How to Train Your Dragon 2",
        lang: "English",
        duration: 102,
        desc: "Hiccup and Toothless are faced with the threat of Drago, a dragon trapper, bent on capturing and dominating over all dragons. However, they are determined to defeat him and restore peace on Berk.",
        poster: "https://m.media-amazon.com/images/M/MV5BMzMwMTAwODczN15BMl5BanBnXkFtZTgwMDk2NDA4MTE@._V1_.jpg",
        trailer: "https://www.youtube.com/watch?v=wyZOaBxgYTo",
    },
    {
        id: 5,
        name: "Death Note",
        lang: "English",
        duration: "NA",
        desc: "An intelligent high school student goes on a secret crusade to eliminate criminals from the world after discovering a notebook capable of killing anyone whose name is written into it.",
        poster: "https://m.media-amazon.com/images/M/MV5BODkzMjhjYTQtYmQyOS00NmZlLTg3Y2UtYjkzN2JkNmRjY2FhXkEyXkFqcGdeQXVyNTM4MDQ5MDc@._V1_FMjpg_UX1000_.jpg",
        trailer: "https://www.youtube.com/watch?v=NlJZ-YgAt-c",
    },
    {
        id: 6,
        name: "Coco",
        lang: "English",
        duration: 105,
        desc: "Miguel pursues his love for singing in spite of his family's ban on music. He stumbles into the Land of the Dead, where he learns about his great-great-grandfather who was a legendary singer.",
        poster: "https://m.media-amazon.com/images/M/MV5BYjQ5NjM0Y2YtNjZkNC00ZDhkLWJjMWItN2QyNzFkMDE3ZjAxXkEyXkFqcGdeQXVyODIxMzk5NjA@._V1_.jpg",
        trailer: "https://www.youtube.com/watch?v=Rvr68u6k5sI",
    },
    {
        id: 7,
        name: "A Whisker Away",
        lang: "English",
        duration: 104,
        desc: "Secretly in love with her classmate Kento, Miyo takes the help of a mysterious mask and transforms into a cat to get closer to him. However, trouble ensues when she begins to lose herself.",
        poster: "https://m.media-amazon.com/images/M/MV5BNDI5ODBhYzMtNDc4Yi00NjEwLWJiZWUtMGE2Mzc4MGVjN2E0XkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg",
        trailer: "https://www.youtube.com/watch?v=nZ3SUUtymJw",
    },
    {
        id: 8,
        name: "Rio",
        lang: "English",
        duration: 96,
        desc: "When Blu, a domesticated macaw from small-town Minnesota, meets the fiercely independent Jewel, he takes off on an adventure to Rio de Janeiro with the bird of his dreams.",
        poster: "https://m.media-amazon.com/images/M/MV5BMTU2MDY3MzAzMl5BMl5BanBnXkFtZTcwMTg0NjM5NA@@._V1_FMjpg_UX1000_.jpg",
        trailer: "https://www.youtube.com/watch?v=P1GRO31ve5Q",
    },
];